import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDateWithTime } from "../../../../shared/utility";
import { classNames } from "primereact/utils";

export default function OrderItemsSubTable1(props) {
  const {
    askDeleteShippingItem,
    data,
    loadingRows,
    rowDetails,
    openQuickScanPopupWithFetchLatest,
  } = props;

  if (loadingRows[data.id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.id];
  if (!detail) return null;

  const shippingItemQuantityBody = (rowData) => {
    let text = 1;
    if (rowData.is_lot) {
      text = rowData.shippingItems.length;
    }
    return <p>{text}</p>;
  };

  const shippingItemActionTemplate = (rowData, row) => {
    return (
      <div className="ml-10">
        <button
          className={classNames(
            rowData.is_quick_scan ? null : "hidden",
            "rounded-md bg-main-purple px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          )}
          onClick={() => openQuickScanPopupWithFetchLatest(rowData)}
        >
          Edit
        </button>
        {/*  <button
            onClick={() => {
            }}
            className="ml-2 rounded-md bg-main-purple px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Receiving Info
          </button> */}
        <button
          onClick={() => askDeleteShippingItem(rowData)}
          className="ml-2 rounded-md bg-red-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          Delete
        </button>
      </div>
    );
  };

  const packagingDateTemplate = (rowData) => {
    return <p>{formatDateWithTime(rowData.packaging_date)}</p>;
  };

  const packagingSizeTemplate = (rowData) => {
    return <p>{rowData.packing_size} kg</p>;
  };

  const barcodeBody = (rowData) => {
    let fontColor = null;
    let text = rowData.shipping_barcode;

    if (rowData.is_lot) {
      fontColor = "text-indigo-800";
      text = rowData.product_lot;
    }
    return <p className={classNames(fontColor, "font-medium")}>{text}</p>;
  };

  return (
    <div>
      <DataTable
        value={rowDetails[data.id]}
        tableClassName="min-w-full bg-white divide-y divide-gray-300"
        cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2"
      >
        <Column header="Barcode/Lot" body={barcodeBody}></Column>
        <Column header="Quantity" body={shippingItemQuantityBody}></Column>
        <Column header="Packing Size" body={packagingSizeTemplate}></Column>
        <Column header="Packaged date" body={packagingDateTemplate}></Column>
        <Column header="" body={shippingItemActionTemplate} />
      </DataTable>
    </div>
  );
}
